module.exports = __webpack_public_path__ + "static/img/25.e995a49.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/nbaip/sku/T恤/25.png
// module id = cOnH
// module chunks = 0